import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';
import './style.scss'

type IDateSelector = {
    value: Array<number> | [],
    onChange: (value: Array<number>) => void
}

const DaysSelector: React.FC<IDateSelector> = ({ value, onChange }) => {
    const [selectedDays, setSelectedDays] = useState<number[]>([]);
    const availableDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

    const toggleDay = (index: number) => {
        const updatedDays = selectedDays.includes(index)
            ? selectedDays.filter((selectedIndex) => selectedIndex !== index)
            : [...selectedDays, index]
        setSelectedDays(updatedDays);
        onChange(updatedDays)
    };

    useEffect(() => {
        setSelectedDays(value)
    }, [value])

    return (
        <div className='days-container'>
            {availableDays.map((day, index) => (
                <Tooltip title={`Click to ${selectedDays.includes(index) ? 'un' : ''}select`}>
                    <Button
                        key={day}
                        variant={selectedDays.includes(index) ? 'contained' : 'outlined'}
                        onClick={() => toggleDay(index)}
                    >
                        {day}
                    </Button>
                </Tooltip>
            ))}
        </div>
    );
};

export default DaysSelector;
